<template>
    <div class="min-w-100">
        {{ option }}
    </div>
</template>

<script>
export default {
    name: "dropdown-cell",
    props: {
        cell: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
    },
    computed: {
        option() {
            let option = this.column.options.find(
                (o) => o.id === this.cell.optionId
            );
            return option ? option.text : "-";
        },
    },
};
</script>